import {Table, TableColumn, useSortableTable} from '@hm/fundamental'
import {Tooltip} from '@mui/material'
import React, {useCallback, useRef, useState} from 'react'

import {type ScenarioRow} from '../types'

const TruncatedPath: React.FC<{text: string}> = ({text}) => {
  const ref = useRef<HTMLDivElement>(null)
  const [isTruncated, setIsTruncated] = useState(false)

  const checkTruncation = useCallback(() => {
    const el = ref.current
    if (el) setIsTruncated(el.scrollHeight > el.clientHeight)
  }, [])

  return (
    <Tooltip
      title={isTruncated ? text : ''}
      placement="bottom-start"
      slotProps={{tooltip: {sx: {maxWidth: 500}}}}
    >
      <div ref={ref} onMouseEnter={checkTruncation} className="line-clamp-2 overflow-hidden">
        {text}
      </div>
    </Tooltip>
  )
}

interface FlowScenariosTableProps {
  scenarios: ScenarioRow[]
  scenariosLabel: string
  setupLabel: string
}

export const FlowScenariosTable: React.FC<FlowScenariosTableProps> = ({
  scenarios,
  scenariosLabel,
  setupLabel
}) => {
  const columns: TableColumn<ScenarioRow>[] = [
    {
      id: 'path',
      label: scenariosLabel,
      sortable: false,
      headerClassName: 'py-3',
      render: (row) => <TruncatedPath text={row.path} />
    },
    {
      id: 'setups',
      label: setupLabel,
      sortable: false,
      headerClassName: 'py-3'
    }
  ]

  const config = useSortableTable<ScenarioRow>(columns)

  return <Table config={config} data={scenarios} breakpoint="sm" />
}
